import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/indicator-blobs.svg")